module.exports = __webpack_public_path__ + "img/logo-aliaddo-02.703206ec.svg";